import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Layout from '../../../../../../components/mui/Layout';
import TableRowComponent from './TableRowComponent';
import { getArrayList } from '../services';
import { setIsLoading } from '../../../../../../redux/loading/actions/loadingAction';
import { setPerPage, setPage, setPages, setArrayList } from '../redux/actions/commercialStatusAction';
import swalErrors from '../../../../../../hooks/useErrors';
import usePermission from '../../../../../../hooks/usePermission';
import { commercialStatusSuperAdminColumns, commercialStatusAdminColumns, perPages } from '../../../../../../helpers/variablesColumns';

const TableComponent = () => {
	const dispatch = useDispatch();
	const userData = useSelector(({ auth }) => auth.userData);
	const isLoading = useSelector( ({ loading }) => loading.isLoading);
	const refreshTable = useSelector( ({ commercialStatus }) => commercialStatus.refreshTable);
	const perPage = useSelector( ({ commercialStatus }) => commercialStatus.perPage);
	const page = useSelector( ({ commercialStatus }) => commercialStatus.page);
	const search = useSelector( ({ commercialStatus }) => commercialStatus.search);
	const realState = useSelector(({ commercialStatus }) => commercialStatus.realState);
	const pages = useSelector( ({ commercialStatus }) => commercialStatus.pages);
	const arrayList = useSelector( ({ commercialStatus }) => commercialStatus.arrayList);
	const permission = usePermission('commercialStatus.list');
	
	/**
	 *
	 * @description Execute endpoint array list of projects
	 * @return dispatch
	 *
	 */
	const handleArrayList = async () => {
		if (permission) {
			await dispatch(setIsLoading(page === 1 ? true : false));
			
			try {
				const param = {
					perPage: perPage,
					page: page,
					search: search === '' ? null : search,
					realstate: realState
				};
				
				const {data} = await getArrayList(param);
				
				if (data.status === 200) {
					await dispatch(setPages(data.data.pages));
					await dispatch(setArrayList(data.data.records));
				}
			} catch (error) {
				await swalErrors(error);
			}
			
			await dispatch(setIsLoading(false));
		}
	};
	
	useEffect(() => {
		handleArrayList();
	}, [
		perPage,
		page,
		refreshTable,
		realState
	]);
	
	/**
	 *
	 * @description Execute dispatch perPage state
	 * @return dispatch
	 *
	 */
	const handleChangePerPage = ({ target }) => dispatch( setPerPage(target.value) );
	
	/**
	 *
	 * @description Execute dispatch page state
	 * @return dispatch
	 *
	 */
	const handleChangePage = (event, value) => dispatch( setPage(value) );
	
	return (
		<Layout.Card className="border-radius-4 mt-4 mr-4 ml-4">
			<Layout.CardContent className="m-0 p-4">
				{permission && (
					<>
						<Layout.TablePagination
							arrayList={arrayList.length}
							perPage={perPage}
							perPages={perPages}
							page={page}
							pages={pages}
							handleChangePerPage={handleChangePerPage}
							handleChangePage={handleChangePage}
						/>
						<Layout.Table>
							<Layout.TableHead columns={userData.roles[0] === 'Super Administrador' ? commercialStatusSuperAdminColumns : commercialStatusAdminColumns} />
							<tbody>
								{isLoading && (
									<Layout.TableRowLoading columns={userData.roles[0] === 'Super Administrador' ? commercialStatusSuperAdminColumns : commercialStatusAdminColumns} />
								)}
								{!isLoading && (
									<>
										{arrayList.length === 0 && (
											<Layout.TableRowNoFound colSpan={userData.roles[0] === 'Super Administrador' ? commercialStatusSuperAdminColumns.length : commercialStatusAdminColumns.length} />
										)}
										{arrayList.length > 0 && (
											arrayList.map(({ id, realstate, order, name, status }, index) => (
												<TableRowComponent
													key={index}
													id={id}
													realState={realstate}
													order={order}
													name={name}
													status={status}
												/>
											))
										)}
									</>
								)}
							</tbody>
						</Layout.Table>
						<Layout.TablePagination
							arrayList={arrayList.length}
							perPage={perPage}
							perPages={perPages}
							page={page}
							pages={pages}
							handleChangePerPage={handleChangePerPage}
							handleChangePage={handleChangePage}
						/>
					</>
				)}
			</Layout.CardContent>
		</Layout.Card>
	);
};

export default TableComponent;
